var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppointmentBookedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 105,
    viewBox: "0 0 100 105",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.679 25.268v32.768l-.023.111a19.647 19.647 0 0 0-2.299-.111c-12.326.004-22.317 9.996-22.32 22.321a21.962 21.962 0 0 0 1.025 6.674l-.044.023H11.183a8.926 8.926 0 0 1-8.928-8.929V25.268h75.424z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.389 8.705h11.384a8.926 8.926 0 0 1 8.928 8.929v7.634H2.255v-7.634a8.926 8.926 0 0 1 8.928-8.929H57.39zM77.679 58.147c11.104 1.146 19.656 10.319 20.02 21.477.366 11.158-7.568 20.87-18.574 22.74-11.006 1.868-21.701-4.68-25.04-15.333a21.964 21.964 0 0 1-1.027-6.674c.004-12.325 9.996-22.317 22.321-22.321.782 0 1.541.044 2.3.111z",
    fill: "#E3EDC3"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#274642"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.447 51.139h34.598a2.233 2.233 0 0 0 0-4.465H20.447a2.232 2.232 0 1 0 0 4.465zM41.16 61.183H20.447a2.232 2.232 0 1 0 0 4.465H41.16a2.233 2.233 0 0 0 0-4.465z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.91 56.227V17.634c-.001-6.163-4.997-11.158-11.16-11.16h-9.152V2.231a2.232 2.232 0 1 0-4.464 0v4.241H24.777v-4.24a2.232 2.232 0 1 0-4.465 0v4.24h-9.151C4.998 6.476.003 11.471 0 17.633v60.492c.003 6.163 4.998 11.158 11.16 11.16h41.318a24.97 24.97 0 0 0 8.192 10.76 24.267 24.267 0 0 0 14.665 4.866 24.541 24.541 0 0 0 18.17-41.049 24.148 24.148 0 0 0-13.594-7.635zm-68.727-45.29h9.152v4.264a2.233 2.233 0 0 0 4.464 0v-4.264h30.358v4.264a2.233 2.233 0 0 0 4.464 0v-4.264h9.152a6.717 6.717 0 0 1 6.696 6.697v5.402H4.487v-5.402a6.716 6.716 0 0 1 6.696-6.697zM4.487 78.126V27.5h70.96v28.304h-.068A24.59 24.59 0 0 0 51.228 84.82H11.183a6.716 6.716 0 0 1-6.696-6.696zm70.892 22.321a20.041 20.041 0 0 1-12.009-3.973 20.083 20.083 0 0 1 12.01-36.182c.692 0 1.383.044 2.075.111 10.641 1.087 18.561 10.327 18.007 21.01-.553 10.681-9.386 19.054-20.083 19.034z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.714 72.344 72.456 85l-6.854-6.875a2.224 2.224 0 1 0-3.146 3.148l8.415 8.415c.418.42.99.654 1.585.647a2.16 2.16 0 0 0 1.54-.626l14.82-14.174a2.223 2.223 0 0 0 .068-3.146 2.27 2.27 0 0 0-3.17-.045z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppointmentBookedIcon);
export default __webpack_public_path__ + "static/media/appointment-booked-icon.d6c142062b8a5e32f941e086030d7262.svg";
export { ForwardRef as ReactComponent };